import React, { useEffect, useState, useMemo } from "react";
import styles from "./AnimatedBackground.module.css";
import iconA from "../Logos/roticons.png";

const AnimatedBackground = ({ children }) => {
  const [cubeCount, setCubeCount] = useState(0);
  const [allowAnimate, setAllowAnimate] = useState(true);

  useEffect(() => {
    try {
      const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
      const update = () => setAllowAnimate(!mq.matches);
      update();
      mq.addEventListener?.("change", update);
      return () => mq.removeEventListener?.("change", update);
    } catch {
      return undefined;
    }
  }, []);

  useEffect(() => {
    if (!allowAnimate) {
      setCubeCount(0);
      return;
    }

    try {
      const coarse = window.matchMedia("(pointer: coarse)").matches;
      const verySmall = window.matchMedia("(max-width: 380px)").matches;
      setCubeCount(verySmall ? 12 : coarse ? 16 : 18);
    } catch {
      setCubeCount(18);
    }
  }, [allowAnimate]);

  const cubeIndexes = useMemo(
    () => Array.from({ length: cubeCount }, (_, i) => i),
    [cubeCount]
  );

  return (
    <div
      className={styles.shell}
      style={{
        "--icon-a": `url(${iconA})`,
        "--icon-b": `url(${iconA})`,
      }}
    >
      {allowAnimate && cubeCount > 0 && (
        <ul className={styles.bgCubes} aria-hidden="true">
          {cubeIndexes.map((i) => (
            <li
              key={i}
              className={styles.cube}
              style={{
                "--i": (i % 18) + 6,
                "--n": (i % 12) + 4,
                "--x": `${(i * 37) % 100}%`,
                "--y": `${(i * 57) % 100}%`,
              }}
            />
          ))}
        </ul>
      )}

      {children}
    </div>
  );
};

export default AnimatedBackground;